import { type Path } from 'react-hook-form';

import { type ExamCenterProctorDetailsFormInput } from './exam-center-proctor-details-form-schema';

type PathOfExamCenterProctorDetailsFormInput = Path<ExamCenterProctorDetailsFormInput>;

export const EXAM_CENTER_PROCTOR_DETAILS_FORM_FIELDS_NAME = {
  email: 'personal.email',
  phoneNumber: 'personal.phoneNumber',
  address: 'personal.address',
  employeeId: 'employeeInfo.code',
  position: 'employeeInfo.position',
  department: 'employeeInfo.department',
} as const satisfies Record<string, PathOfExamCenterProctorDetailsFormInput>;
